import { ApiClientService, EntityApiService, RequestConfig, SearchResponseType } from '@dfl/react-security';
import { ICarrier } from 'modules/inventory/provider/carriers/interfaces';

class CarrierService extends EntityApiService<ICarrier> {
  searchClean = (params?: any, config?: RequestConfig): Promise<SearchResponseType<ICarrier>> => {
    const projections = {
      owner: 0,
      space: 0,
      tags: 0,
      updatedAt: 0,
    };
    return this.search({ ...params, projections }, config);
  };

  updateActive = (carrierId: string, params?: any) => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${carrierId}/active`), params));
  };

  updateContact = (carrierId: string, params?: any) => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${carrierId}/contacts`), params));
  };

  updateAddress = (carrierId: string, params?: any) => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${carrierId}/address`), params));
  };

  updateName = (carrierId: string, params?: any) => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${carrierId}/name`), params));
  };

  getOne = (carrierId: string, config?: RequestConfig | undefined) => {
    return this.handleResponse(
      ApiClientService.get(this.getPath(`/${carrierId}`), config).then((data) => {
        return {
          ...data,
          data: {
            ...data.data,
            tags: {
              carrier: data?.data?.tags,
            },
          },
        };
      }),
    );
  };

  updateTags = (payload: Partial<ICarrier>): any => {
    const { _id, tags } = payload;
    if (_id) {
      return ApiClientService.patch(this.getPath(`/${_id}`), {
        tags,
      });
    }
    throw new Error('You must be inside a _id');
  };

  deleteMany = (ids: string[]): any => {
    if (ids) {
      return ApiClientService.patch(this.getPath('/bulk/remove'), {
        ids,
      });
    }
    throw new Error('You must be inside a ids array');
  };

  changeVisibilityMany = ({ ids, visible }: { ids: string[]; visible: string | boolean }): any => {
    if (ids) {
      return ApiClientService.patch(this.getPath('/bulk/visibility'), {
        ids,
        visible,
      });
    }
    throw new Error('You must be inside a ids array and visible');
  };

  updateProvider = (provider: Partial<ICarrier>) => {
    return ApiClientService.patch(this.getPath(`/${provider._id as string}/logistic`), provider);
  };
}

export default new CarrierService('/ms-inventory/api/carrier');
